export default __webpack_public_path__ + "static/media/logo.89ed3d34.png";